import React from 'react';
import PropTypes from 'prop-types';

import { StatsSection } from '../common/stats-section';
import { BioStats } from './components/BioStats';
import { BioAwards } from './components/BioAwards';

/**
 * @returns {JSX.Element} Component.
 */
export const PlayerProfileBio = ( {data} ) => {

    return (
        <StatsSection.Main>
            <StatsSection.Heading isSmallModifier={true}>
                {PULSE.I18N.lookup( 'label.stats.playerProfile' ) }
            </StatsSection.Heading>
            <StatsSection.Content>
                <StatsSection.ContentHeader>
                    <StatsSection.ContentHeaderHeading cssClass="stats-section-content-header__heading--full-width">
                        <BioStats data={data}/>
                    </StatsSection.ContentHeaderHeading>
                </StatsSection.ContentHeader>
                <StatsSection.ContentBody>
                    <BioAwards data={data}/>
                </StatsSection.ContentBody>
            </StatsSection.Content>
        </StatsSection.Main>
    );
};

PlayerProfileBio.propTypes = {
    data: PropTypes.object.isRequired
};